import { Routes } from '@angular/router';
import { plannedFeatureForUrl } from './feature-availability';

/** Annotate planned routes without replacing their pages, editors or authorization. */
export function withFeatureAvailability(routes: Routes, parent = ''): Routes {
    return routes.map(route => {
        const path = `${parent}/${route.path ?? ''}`.replace(/\/+/g, '/');
        const feature = plannedFeatureForUrl(path);
        return {
            ...route,
            data: feature && !route.redirectTo ? { ...route.data, plannedFeatureId: feature.id } : route.data,
            children: route.children ? withFeatureAvailability(route.children, path) : undefined,
        };
    });
}
